import React from "react";
import PropTypes from "prop-types";
import Toast from "./Toast.js";

/**
 * ToastContainer
 * Renderiza uma lista de toasts empilhados no canto superior direito.
 * Use junto com o hook useToast().
 */
export default function ToastContainer({ toasts = [], onRemove }) {
  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="toast-stack" aria-live="polite">
      {toasts.map((t) => (
        <Toast
          key={t.id}
          message={t.message}
          type={t.type}
          duration={t.duration}
          onClose={() => onRemove(t.id)}
        />
      ))}
    </div>
  );
}

ToastContainer.propTypes = {
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      message: PropTypes.string.isRequired,
      type: PropTypes.oneOf(["success", "error", "warning", "info"]),
      duration: PropTypes.number,
    })
  ),
  onRemove: PropTypes.func.isRequired,
};
